import React from 'react'
import PropTypes from 'prop-types'

import { SITE_PATH, SITE_EDIT_PATH } from 'config'
import { Switch, Route, Link } from 'react-router-dom'


class SiteName extends React.Component {
  static propTypes = {
    site: PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  }

  renderEditLink = () => {
    const siteEditPath = SITE_EDIT_PATH.replace(':site', this.props.site.key);

    return (
      <Link to={ siteEditPath }>
        <i className="zmdi zmdi-hc-lg zmdi-settings" />
      </Link>
    )
  }

  renderReturnLink = () => {
    // /sites/:site
    const sitePath = SITE_PATH.replace(':site', this.props.site.key);

    return (
      <Link to={ sitePath }>
        <i
          className="zmdi zmdi-hc-lg zmdi-chevron-right"
          style={ { fontSize: '32px', color: '#f16000', padding: '0 2px' } }
        />
      </Link>
    )
  }

  render() {
    return (
      <div className="site-name-card card mb-3">
        <h5 className="site-name-card__title m-0 text-ellipsis">{ this.props.site.name }</h5>
        <div className="site-name-card__icon">
          <Switch>
            { /* /sites/:site/edit */ }
            <Route path={ SITE_EDIT_PATH } render={ this.renderReturnLink } />
            { /* other */ }
            <Route render={ this.renderEditLink } />
          </Switch>
        </div>
      </div>
    )
  }
}

export default SiteName



// WEBPACK FOOTER //
// ./src/components/sites/sidebar/site-name.js